import { Box } from '@material-ui/core';
import Text from '../../../../components/Text';


const TitleBox = ({ title, titleColor, children, gridGap = '0.62rem', style, ...rest }) => {

  return (
    <Box display="flex" flexDirection="column" gridGap={gridGap} style={style} {...rest}>
      <Text color={titleColor ?? '#2E4469'} fontSize="1rem">
        {title}
      </Text>
      <Box>{children}</Box>
    </Box>
  );
};

export default TitleBox;
